import { useMemo } from 'react';

import { Item } from '../Autocomplete/types';
import { Location } from './types';

import { useConfig } from '../context';

export const useCityOptions = (options: Item<Location>[]) => {
	const {
		SearchForm: { locationGroups }
	} = useConfig();

	const [additionalOptions, otherOptions] = useMemo(() => {
		const additionalOptions: Item<Location>[] = [];
		const otherOptions: Item<Location>[] = [];

		options.forEach(option => {
			if ('type' in option && locationGroups.additionalGroupTypes.includes(option.type)) {
				additionalOptions.push(option);
			} else {
				otherOptions.push(option);
			}
		});

		return [additionalOptions, otherOptions];
	}, [options]);

	const dropdownOptions =
		locationGroups.showAdditionalGroups && additionalOptions.length
			? [...additionalOptions, ...(options.length < 4 ? otherOptions : [])]
			: otherOptions;

	const showAdditionalButton =
		dropdownOptions.length <
		[...otherOptions, ...(locationGroups.showAdditionalGroups ? additionalOptions : [])].length;

	return { dropdownOptions, showAdditionalButton };
};
